<template>
	<page>
		<row class="align-content-center justify-center">
			<c-col cols="8">
				<v-card>
					<v-toolbar flat color="primary" dark>
						<v-toolbar-title>הפקת דוחות</v-toolbar-title>
					</v-toolbar>
					<v-tabs vertical>
						<v-tab>
							דו"ח לקוח חודשי/יומי
						</v-tab>
						<v-tab v-if="isAdmin">
							דו"ח מודד חודשי
						</v-tab>
						<v-tab v-if="isAdmin">
							דו"ח HTM שנתי
						</v-tab>
						<v-tab v-if="isAdmin">
							דו"ח לקוחות שנתי
						</v-tab>
						<v-tab-item>
							<row class="align-content-center justify-center">
								<c-col cols="8">
									<client-monthly-report/>
								</c-col>
							</row>
						</v-tab-item>
						<v-tab-item v-if="isAdmin">
							<row class="align-content-center justify-center">
								<c-col lg="8">
									<surveyor-monthly-report/>
								</c-col>
							</row>
						</v-tab-item>
						<v-tab-item v-if="isAdmin">
							<row class="align-content-center justify-center">
								<c-col lg="8">
									<htm-year-report/>
								</c-col>
							</row>
						</v-tab-item>
						<v-tab-item v-if="isAdmin">
							<row class="align-content-center justify-center">
								<c-col lg="8">
									<customer-yearly-report/>
								</c-col>
							</row>
						</v-tab-item>
					</v-tabs>
				</v-card>

			</c-col>
		</row>
	</page>
</template>

<script>
	import ClientMonthlyReport from "dev/view/reports/ClientMonthlyReport";
	import SurveyorMonthlyReport from "dev/view/reports/SurveyorsMonthlyReport";
	import HtmYearReport from "dev/view/reports/HtmYearReport";
	import CustomerYearlyReport from "dev/view/reports/CustomerYearlyReport.vue";

	export default {
		name: "reports-view",
		props: [],
		components: {CustomerYearlyReport, HtmYearReport, SurveyorMonthlyReport, ClientMonthlyReport},
		data() {
			return {};
		},
		computed: {
			isAdmin() {
				return this.$store.getters.isAdmin;
			}
		},
		methods: {}
	};
</script>

